import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, getActAs, setActAs } from "@/lib/api";
import { MagnifyingGlass, UserSwitch, SignOut } from "@phosphor-icons/react";

export function useActAs() {
  const [a, setA] = useState(getActAs());
  useEffect(() => {
    const h = () => setA(getActAs());
    window.addEventListener("act-as-change", h);
    return () => window.removeEventListener("act-as-change", h);
  }, []);
  return a;
}

export function ActAsBanner({ actAs }) {
  const nav = useNavigate();
  return (
    <div className="mx-4 md:mx-10 mt-4 rounded-md border border-[#F59E0B]/50 bg-[#F59E0B]/10 px-4 py-3 flex flex-wrap items-center gap-3 text-sm" data-testid="act-as-banner">
      <UserSwitch size={18} className="text-[#F59E0B]" />
      <span className="flex-1 min-w-[200px]">
        <strong className="text-[#F59E0B]">Modo administrador</strong> · atuando como{" "}
        <span data-testid="act-as-nome" className="font-medium">{actAs.razao_social}</span>
        <span className="text-[#94A3B8]"> ({actAs.cnpj}) — as ações ficam registradas em seu nome.</span>
      </span>
      <button data-testid="act-as-trocar" onClick={() => { setActAs(null); nav("/fornecedor"); }}
              className="px-3 py-1.5 rounded border border-[#F59E0B]/60 text-[#F59E0B] text-xs">Trocar fornecedor</button>
      <button data-testid="act-as-sair" onClick={() => { setActAs(null); nav("/dashboard"); }}
              className="px-3 py-1.5 rounded border border-[#334155] text-xs flex items-center gap-1"><SignOut size={12} /> Voltar ao sistema interno</button>
    </div>
  );
}

export function ActAsSelector() {
  const [items, setItems] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/admin/fornecedores").then((r) => setItems(r.data.items)); }, []);
  const lista = (items || []).filter((f) => `${f.razao_social} ${f.cnpj} ${f.email}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="space-y-6 max-w-4xl" data-testid="act-as-selector">
      <div>
        <div className="uppercase-label">Administração · Área do Fornecedor</div>
        <h1 className="font-heading text-4xl tracking-tight mt-2">Escolha o fornecedor</h1>
        <p className="text-sm text-[#94A3B8] mt-2">Você verá e poderá agir exatamente como a empresa selecionada. Todas as ações ficam registradas como feitas pelo administrador em nome do fornecedor.</p>
      </div>
      <div className="relative">
        <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#94A3B8]" />
        <input data-testid="act-as-busca" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Razão social, CNPJ ou e-mail…" className="tce-input w-full pl-10 pr-3 py-2.5 rounded-md text-sm" />
      </div>
      <div className="tce-card divide-y divide-[#334155]">
        {items === null && <p className="p-5 text-[#94A3B8]">Carregando…</p>}
        {items && !lista.length && <p className="p-5 text-[#94A3B8]">Nenhum fornecedor encontrado.</p>}
        {lista.map((f, i) => (
          <button key={f.id} data-testid={`act-as-opcao-${i}`}
                  onClick={() => setActAs({ id: f.id, razao_social: f.razao_social, cnpj: f.cnpj, email: f.email })}
                  className="w-full text-left px-5 py-4 hover:bg-[#1E293B] flex items-center justify-between gap-4">
            <div>
              <div className="font-medium">{f.razao_social}</div>
              <div className="text-xs text-[#94A3B8]">{f.cnpj} · {f.email}{f.active === false ? " · inativo" : ""}</div>
            </div>
            <span className="text-xs text-[#FFDF00] font-mono">{f.contratos_total} contrato(s)</span>
          </button>
        ))}
      </div>
    </div>
  );
}
